<app-ias-loader *ngIf="loading"></app-ias-loader>

<!-- Bootstrap Toast -->
<div class="toast-container position-fixed top-0 end-0 p-3">
  <div id="liveToast" class="toast align-items-center text-bg-{{ toastType }} border-0" role="alert"
    aria-live="assertive" aria-atomic="true">
    <div class="d-flex">
      <div class="toast-body">
        {{ toastMessage }}
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
        aria-label="Close"></button>
    </div>
  </div>
</div>

<div class="main-login-component d-flex align-items-center">
  <div class="intro-image-div position-relative" [routerLink]="''" style="cursor: pointer;">
  </div>

  <div class="login-form-div d-flex flex-column align-items-center">
    <div class="inneradjustment" *ngIf="!showOtpStep">
      <h1>Login to your account</h1>
      <div class="tabs-div mt-4">
        <div class="formstab" [class.active]="activeTab === 'email'" (click)="switchTab('email')">
          Email Login
        </div>

        <div class="formstab" [class.active]="activeTab === 'mobile'" (click)="switchTab('mobile')">
          Mobile Login
        </div>
<!-- 
        <div class="googletab d-flex align-items-center gap-2 justify-content-center" (click)="loginWithGoogle()">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
            <path fill="#FFC107"
              d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z">
            </path>
            <path fill="#FF3D00"
              d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z">
            </path>
            <path fill="#4CAF50"
              d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z">
            </path>
            <path fill="#1976D2"
              d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z">
            </path>
          </svg>
          Google
        </div> -->
      </div>
      <form [formGroup]="emailForm" (ngSubmit)="onSubmit()">

        <!-- Email OR Mobile -->
        <label for="email">
          {{ activeTab === 'mobile' ? 'Mobile Number' : 'Email Address' }}
        </label>
        <input type="text" id="email" formControlName="email"
          [placeholder]="activeTab === 'mobile' ? 'Enter Mobile Number' : 'Enter Email Address'"
          (input)="onInputChange($event)" />

        <div *ngIf="email?.touched && email?.invalid" class="error-message">
          <small *ngIf="email?.errors?.['required']">
            {{ activeTab === 'mobile' ? 'Mobile number is required' : 'Email is required' }}
          </small>

          <small *ngIf="email?.errors?.['invalidInput']">
            {{ activeTab === 'mobile' ? 'Enter valid 10-digit mobile number' : 'Enter valid email address' }}
          </small>
        </div>


        <!-- PASSWORD FIELD (Hidden for Mobile Login) -->
        <div *ngIf="!isMobileLogin">
          <label for="password">Password</label>
          <div class="password-input">
            <input [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password"
              placeholder="Enter your password" />

            <button type="button" (click)="togglePasswordVisibility()" class="eye-button">
              <!-- Eye Open SVG -->
              <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"
                fill="none">
                <g clip-path="url(#clip0_50828_258)">
                  <path
                    d="M9.49996 4.75002C12.5004 4.75002 15.1762 6.43627 16.4825 9.10419C15.1762 11.7721 12.5004 13.4584 9.49996 13.4584C6.49954 13.4584 3.82371 11.7721 2.51746 9.10419C3.82371 6.43627 6.49954 4.75002 9.49996 4.75002ZM9.49996 3.16669C5.54163 3.16669 2.16121 5.62877 0.791626 9.10419C2.16121 12.5796 5.54163 15.0417 9.49996 15.0417C13.4583 15.0417 16.8387 12.5796 18.2083 9.10419C16.8387 5.62877 13.4583 3.16669 9.49996 3.16669ZM9.49996 7.12502C10.5925 7.12502 11.4791 8.01169 11.4791 9.10419C11.4791 10.1967 10.5925 11.0834 9.49996 11.0834C8.40746 11.0834 7.52079 10.1967 7.52079 9.10419C7.52079 8.01169 8.40746 7.12502 9.49996 7.12502ZM9.49996 5.54169C7.53663 5.54169 5.93746 7.14085 5.93746 9.10419C5.93746 11.0675 7.53663 12.6667 9.49996 12.6667C11.4633 12.6667 13.0625 11.0675 13.0625 9.10419C13.0625 7.14085 11.4633 5.54169 9.49996 5.54169Z"
                    fill="#A9ACB1" />
                </g>
                <defs>
                  <clipPath id="clip0_50828_258">
                    <rect width="19" height="19" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <!-- Eye Closed SVG -->
              <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"
                fill="none">
                <g clip-path="url(#clip0_50828_300)">
                  <path
                    d="M9.50008 4.74999C12.5005 4.74999 15.1763 6.43624 16.4826 9.10416C16.0155 10.07 15.3584 10.9012 14.5747 11.5742L15.6909 12.6904C16.7913 11.7167 17.6622 10.4975 18.2084 9.10416C16.8388 5.62874 13.4584 3.16666 9.50008 3.16666C8.49467 3.16666 7.52883 3.32499 6.61841 3.61791L7.92467 4.92416C8.43925 4.82124 8.96175 4.74999 9.50008 4.74999ZM8.653 5.65249L10.2917 7.29124C10.743 7.48916 11.1072 7.85333 11.3051 8.30458L12.9438 9.94333C13.0072 9.67416 13.0547 9.38916 13.0547 9.09624C13.0626 7.13291 11.4634 5.54166 9.50008 5.54166C9.20717 5.54166 8.93008 5.58124 8.653 5.65249ZM1.59133 3.06374L3.713 5.18541C2.42258 6.19874 1.40133 7.54458 0.791748 9.10416C2.16133 12.5796 5.54175 15.0417 9.50008 15.0417C10.7034 15.0417 11.8592 14.8121 12.9201 14.3925L15.6276 17.1L16.7438 15.9837L2.70758 1.93958L1.59133 3.06374ZM7.52883 9.00124L9.59508 11.0675C9.56342 11.0754 9.53175 11.0833 9.50008 11.0833C8.40758 11.0833 7.52092 10.1967 7.52092 9.10416C7.52092 9.06458 7.52883 9.04083 7.52883 9.00124ZM4.83717 6.30958L6.22258 7.69499C6.0405 8.13041 5.93758 8.60541 5.93758 9.10416C5.93758 11.0675 7.53675 12.6667 9.50008 12.6667C9.99883 12.6667 10.4738 12.5637 10.9013 12.3817L11.6772 13.1575C10.9805 13.3475 10.2522 13.4583 9.50008 13.4583C6.49967 13.4583 3.82383 11.7721 2.51758 9.10416C3.07175 7.97208 3.87925 7.03791 4.83717 6.30958Z"
                    fill="#222222" />
                </g>
                <defs>
                  <clipPath id="clip0_50828_300">
                    <rect width="19" height="19" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>

          <div *ngIf="password?.touched && password?.invalid" class="error-message">
            <small>Password is required.</small>
          </div>
        </div>

        <div class="forgot" *ngIf="!isMobileLogin">
          <a [routerLink]="'/forget-password'">Forgot Password?</a>
        </div>

        <button class="login-btn" type="submit" [disabled]="
    activeTab === 'email'
      ? email?.invalid || password?.invalid
      : email?.invalid
  ">
          Continue
        </button>
        <div class="signup-text">
          Don’t have an account? <a [routerLink]="'/signup'">Sign up</a>
        </div>

        <div class="warning-box">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
              d="M6.33325 10.3333H7.66658V6.33331H6.33325V10.3333ZM6.99992 4.99998C7.18881 4.99998 7.34714 4.93609 7.47492 4.80831C7.6027 4.68053 7.66658 4.5222 7.66658 4.33331C7.66658 4.14442 7.6027 3.98609 7.47492 3.85831C7.34714 3.73054 7.18881 3.66665 6.99992 3.66665C6.81103 3.66665 6.6527 3.73054 6.52492 3.85831C6.39714 3.98609 6.33325 4.14442 6.33325 4.33331C6.33325 4.5222 6.39714 4.68053 6.52492 4.80831C6.6527 4.93609 6.81103 4.99998 6.99992 4.99998ZM6.99992 13.6666C6.0777 13.6666 5.21103 13.4916 4.39992 13.1416C3.58881 12.7916 2.88325 12.3166 2.28325 11.7166C1.68325 11.1166 1.20825 10.4111 0.858252 9.59998C0.508252 8.78887 0.333252 7.9222 0.333252 6.99998C0.333252 6.07776 0.508252 5.21109 0.858252 4.39998C1.20825 3.58887 1.68325 2.88331 2.28325 2.28331C2.88325 1.68331 3.58881 1.20831 4.39992 0.858313C5.21103 0.508313 6.0777 0.333313 6.99992 0.333313C7.92214 0.333313 8.78881 0.508313 9.59992 0.858313C10.411 1.20831 11.1166 1.68331 11.7166 2.28331C12.3166 2.88331 12.7916 3.58887 13.1416 4.39998C13.4916 5.21109 13.6666 6.07776 13.6666 6.99998C13.6666 7.9222 13.4916 8.78887 13.1416 9.59998C12.7916 10.4111 12.3166 11.1166 11.7166 11.7166C11.1166 12.3166 10.411 12.7916 9.59992 13.1416C8.78881 13.4916 7.92214 13.6666 6.99992 13.6666ZM6.99992 12.3333C8.48881 12.3333 9.74992 11.8166 10.7833 10.7833C11.8166 9.74998 12.3333 8.48887 12.3333 6.99998C12.3333 5.51109 11.8166 4.24998 10.7833 3.21665C9.74992 2.18331 8.48881 1.66665 6.99992 1.66665C5.51103 1.66665 4.24992 2.18331 3.21659 3.21665C2.18325 4.24998 1.66659 5.51109 1.66659 6.99998C1.66659 8.48887 2.18325 9.74998 3.21659 10.7833C4.24992 11.8166 5.51103 12.3333 6.99992 12.3333Z"
              fill="#A16800" />
          </svg>
          <p>
            This facility is strictly for serving and retired IAS officers only.
            Unauthorized access is prohibited.
          </p>
        </div>

      </form>
    </div>

    <!-- OTP STEP (UNCHANGED) -->
    <div class="second-step" *ngIf="showOtpStep">
      <h1>Enter OTP to Verify</h1>
      <h4>An OTP has been sent to {{ emailForm.value.email }}</h4>

      <form [formGroup]="otpForm" (ngSubmit)="submitOtp()">
        <div class="otp-inputs">
          <input *ngFor="let ctrl of otpControls; let i = index" type="text" maxlength="1" [formControlName]="ctrl"
            (input)="onOtpInput($event, i)" (keydown)="handleKeyDown($event, i)" />
        </div>

        <button class="login-btn" type="submit">Continue</button>

        <span class="d-flex align-items-center gap-2 mt-2">
          <p class="m-0">Did not get the OTP?</p>
          <span class="resend-text" (click)="!isResendDisabled && onResendOtp()" [class.disabled]="isResendDisabled">
            Resend OTP
          </span>
          in <span class="timer m-0">{{ countdown * 1000 | date:'mm:ss':'UTC' }}</span>
        </span>
      </form>
    </div>
  </div>
</div>